
export function DirectorSection() {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            塾長メッセージ
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            お子様の成長を全力でサポートします
          </p>
        </div>

        <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl shadow-lg overflow-hidden border border-amber-100">
          <div className="flex flex-col md:flex-row items-stretch">
            {/* 塾長写真 */}
            <div className="md:w-2/5 relative">
              <div className="w-full h-80 md:h-full min-h-[400px]">
                <img
                  src="https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/ad20518c3a2816d56ad3093932ea9584.jpeg"
                  alt="学習塾NICK 塾長"
                  title="廿日市市 学習塾NICK 塾長"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* メッセージ */}
            <div className="md:w-3/5 p-8 md:p-10 flex flex-col justify-center">
              <div className="mb-6">
                <span className="inline-block bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-4">
                  塾長あいさつ
                </span>
                <h3 className="text-2xl md:text-3xl font-black text-gray-800 leading-tight mb-2">
                  「わかった！」の笑顔が私たちの原動力です
                </h3>
              </div>

              <div className="space-y-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <p>はじめまして。学習塾NICKの塾長です。</p>
                <p>
                  私がこの塾を始めたきっかけは、<strong>「勉強のやり方がわからない」</strong>と悩む中学生をたくさん見てきたことです。能力がないのではなく、正しいやり方を知らないだけ。そんな生徒たちに、<strong>勉強のコツ</strong>を伝えたいという想いで指導を続けています。
                </p>
                <p>
                  当塾では、ただ問題を解かせるのではなく、<strong>「なぜそうなるのか」</strong>を一緒に考え、自分で解ける力を育てます。定期テストの点数アップはもちろん、<strong>学ぶ楽しさ</strong>を感じてもらえる授業を心がけています。
                </p>
                <p>
                  お子様の<strong>「できた！」</strong>という笑顔を一緒に増やしていきましょう。まずはお気軽にご相談ください。
                </p>
              </div>

              <div className="mt-8 pt-6 border-t border-amber-200">
                <p className="text-lg font-bold text-gray-800">
                  学習塾NICK 塾長
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  廿日市市大野 |&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
